{
    const header = document.getElementById('header')
    const fullHeightContainers = document.querySelectorAll('[data-fullheight-container]')
    const setContainerHeight = el => el.style.setProperty('min-height', `calc(100vh - ${header.offsetHeight}px)`, 'important')

    fullHeightContainers.forEach(container => setContainerHeight(container))
}
